export function createAtlasServiceLazy(config) {
    let servicePromise;
    const getService = ()=>servicePromise ??= import(/* webpackChunkName: "atlas-service" */ './atlas-service').then(({ createAtlasService })=>createAtlasService(config));
    return {
        predict: async (params)=>(await getService()).predict(params),
        getPlace: async (params)=>(await getService()).getPlace(params),
        searchByPostalCode: async (params)=>(await getService()).searchByPostalCode(params)
    };
}

//# sourceMappingURL=atlas-service-lazy.js.map